export const CACHE_DELETED: string = "duplo-authentication_cacheDeleted";
export const CACHE_CLEARED: string = "duplo-authentication_cacheCleared";

export class Cache {
  private readonly cache: Map<string, any>;

  constructor() {
    this.cache = new Map<string, any>();
    window.addEventListener("storage", (e: StorageEvent) => {
      if (e.key === CACHE_DELETED) {
        this.cache.delete(e.newValue);
        return;
      }
      if (e.key === CACHE_CLEARED) {
        this.cache.clear();
      }
    });
  }

  public has(key: string): boolean {
    return this.cache.has(key);
  }

  public set(key: string, value: any): void {
    this.cache.set(key, value);
  }

  public get(key: string): any | undefined {
    return this.cache.get(key);
  }

  public delete(key: string): boolean {
    const deleted = this.cache.delete(key);
    window.localStorage.setItem(CACHE_DELETED, key);
    window.setTimeout(() => window.localStorage.removeItem(CACHE_DELETED), 200);
    return deleted;
  }

  public clear(): void {
    this.cache.clear();
    window.localStorage.setItem(CACHE_CLEARED, CACHE_CLEARED);
    window.setTimeout(() => window.localStorage.removeItem(CACHE_CLEARED), 200);
  }
}
